/*
  变量名统一用HTTP method结尾，如登录接口为get请求，则变量名为LOGIN_GET
*/
export const baseUrl = "";
//AUTH
export const LOGIN_GET = "/login";
export const QUICK_LOGIN = "/user/wework/auth";
export const VCODE_GET = "/vcode";

//FILE
export const FILE_UPLOAD_POST = "/authorize/upload";
export const FILE_DOWNLOAD_GET = "/sale/file/download";

//AUTHORIZE_GET
export const AUTHORIZE_LIST_GET = "/authorize/list/get";
export const AUTHORIZE_CREATE_POST = "/authorize/create";
export const AUTHORIZE_DOWNLOAD_GET = "/authorize/download";
export const AUTHORIZE_INFO_GET = "/authorize/get";
export const AUTHORIZE_DELETE_POST = "/authorize/delete";

//REPORT
export const REPORT_LIST_POST = "/sales/report/list";
export const REPORT_DETAIL_POST = "/sales/report/detail";
export const REPORT_STATE_POST = "/sales/report/stat";
export const REPORT_EXPORT_POST = "/sales/report/stat/export";
export const REPORT_DOWNLOAD_POST = "/sales/report/stat/download";

//USER_LIST
export const USER_ADD_POST = "/user/add";
export const USER_LIST_POST = "/user/list";
export const USER_DEL_POST = "/user/del";
export const DEPT_TREE_POST = "/dept/tree";
export const DEPT_USER_POST = "/dept/users/list";

//SYS_CONFIG
export const SYS_CONFIGS_POST = "/sys/config/get";
export const CONFIG_SET_POST = "/sys/config/set";